export const actionTalk = "talk";
export const actionDo = "do";
export const systemLabel = "system";
